import React from 'react';

const Page404 = () => {
    return (
        <div className='container'>
            <div className='row justify-content-center'>
                <div className='col-md-6'>
                    <div className='card card-body mt-5'>
                        <h1>Page 404 | Page Not Found</h1>
                        <p>URL / Page you are searching not found!</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Page404;